export default __webpack_public_path__ + "static/media/rubik-v12-latin-900.3b63d1b3.eot";